// Google Ads klikk-ID-er for offline conversion-upload (Iskra-kvalifisert lead).
// Fanges ved chat-start: URL-parametere har prioritet (ferskest), deretter
// Googles egne cookies som overlever navigering (settes av Conversion Linker /
// gtag på landingssiden og lever ~90 dager).
//
// Cookie-format (_gcl_aw / _gcl_gb): "GCL.<timestamp>.<klikk-id>" — vi vil ha
// siste segment. Klikk-ID-en kan selv inneholde punktum, så split på de to
// første punktumene og behold resten.

export interface ClickIds {
  gclid: string | null;
  gbraid: string | null;
  wbraid: string | null;
}

function readCookie(name: string): string | null {
  try {
    const match = document.cookie
      .split("; ")
      .find((c) => c.startsWith(name + "="));
    return match ? decodeURIComponent(match.slice(name.length + 1)) : null;
  } catch {
    return null;
  }
}

function parseGclCookie(raw: string | null): string | null {
  if (!raw) return null;
  // "GCL.1718000000.Cj0KCQjw..." → "Cj0KCQjw..."
  const parts = raw.split(".");
  if (parts.length < 3 || parts[0] !== "GCL") return null;
  return parts.slice(2).join(".") || null;
}

export function getClickIds(): ClickIds {
  let urlGclid: string | null = null;
  let urlGbraid: string | null = null;
  let urlWbraid: string | null = null;
  try {
    const params = new URLSearchParams(window.location.search);
    urlGclid = params.get("gclid");
    urlGbraid = params.get("gbraid");
    urlWbraid = params.get("wbraid");
  } catch {
    /* noop */
  }

  return {
    gclid: urlGclid || parseGclCookie(readCookie("_gcl_aw")),
    gbraid: urlGbraid || parseGclCookie(readCookie("_gcl_gb")),
    wbraid: urlWbraid,
  };
}
